import { render } from "./ReciboProtegido.vue?vue&type=template&id=9081e60c"
import script from "./ReciboProtegido.vue?vue&type=script&lang=js"
export * from "./ReciboProtegido.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__